/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar17 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar17", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M24,4H6C4.895,4,4,4.895,4,6v18c0,1.105,0.895,2,2,2h18c1.105,0,2-0.895,2-2V6C26,4.895,25.105,4,24,4z M12.874,21.543 h-1.792v-5.43h-0.093L9.29,17.261v-1.543l1.792-1.221h1.792V21.543z M20.773,15.879l-2.842,5.664h-1.875l2.925-5.571v-0.098h-3.413 v-1.382h5.205V15.879z M24,10H6V6h18V10z" />
      </svg>
    );
  }
}

IconCalendar17.defaultProps = {
  className: null
};

IconCalendar17.propTypes = {
  className: PropTypes.string
};

export default IconCalendar17;
